import api from '@/api/companies';

const update = (context, payload) => new Promise(((resolve, reject) => {
    api.update(payload)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

const fetchAppSumoLicence = (context, payload) => new Promise(((resolve, reject) => {
    api.fetchAppSumoLicence(payload)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

const finalizeAppSumo = (context, payload) => new Promise(((resolve, reject) => {
    api.finalizeAppSumo(payload)
        .then((response) => {
            context.commit('storeApiKey', response.user.apiKey, { root: true });
            context.commit('users/SET_PROFILE', response.user, { root: true });
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

const companyProgress = (context, payload) => new Promise(((resolve, reject) => {
    api.companyProgress(payload)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

const updateCompanyBillingInformation = (context, payload) => new Promise(((resolve, reject) => {
    api.updateCompanyBillingInformation(payload)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

const uploadCompanyLogo = (context, payload) => new Promise(((resolve, reject) => {
    api.uploadCompanyLogo(payload)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

const deleteCompany = (context, companyId) => new Promise(((resolve, reject) => {
    api.deleteCompany(companyId)
        .then((response) => {
            resolve(response);
        })
        .catch((error) => {
            // eslint-disable-next-line
            console.error(error);
            reject(error);
        });
}));

export default {
    update,
    fetchAppSumoLicence,
    finalizeAppSumo,
    companyProgress,
    updateCompanyBillingInformation,
    uploadCompanyLogo,
    deleteCompany,
};

